module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bf-6fc31e160aec39c1d496a8a13554b6ad.svg";